export const categories = [
  {
    key: 'film',
    name: '影视新闻',
    desc: '院线新片、剧集动态、影视行业观察，第一时间掌握银幕内外的最新消息。',
  },
  {
    key: 'variety',
    name: '综艺资讯',
    desc: '热门综艺、真人秀、舞台竞演与脱口秀，看遍当下最受欢迎的节目内容。',
  },
  {
    key: 'gossip',
    name: '娱乐八卦',
    desc: '明星动态、幕后花絮与话题热度追踪，轻松读懂娱乐圈的每日新鲜事。',
  },
  {
    key: 'music',
    name: '音乐资讯',
    desc: '新歌发布、音乐节现场与榜单动向，与你一起聆听华语与全球音乐潮流。',
  },
  {
    key: 'star',
    name: '明星动态',
    desc: '演员、歌手、导演与综艺嘉宾的最新行程、作品与专访纪实。',
  },
];